import { authGet, authGetConditional, authPost, type ConditionalResponse } from "../http_client.js";
import { PrimedResponses } from "../primed_responses.js";
import type {
  ClaimDailyTaskResponse,
  ClaimStarChestResponse,
  DailyTasksPayloadDto,
} from "../dto/daily_tasks.dto.js";

const DAILY_TASKS_PATH = "api/player/me/daily-tasks?include_locked=1";

export function getDailyTasks(): Promise<DailyTasksPayloadDto>
{
  const primed = PrimedResponses.take<DailyTasksPayloadDto>( "daily_tasks" );
  if ( primed ) return Promise.resolve( primed );
  return authGet<DailyTasksPayloadDto>( DAILY_TASKS_PATH );
}

export function getDailyTasksConditional( etag: string | null ): Promise<ConditionalResponse<DailyTasksPayloadDto>>
{
  const primed = PrimedResponses.take<DailyTasksPayloadDto>( "daily_tasks" );
  if ( primed )
    return Promise.resolve( { status: 200, data: primed, etag: PrimedResponses.take<string | null>( "daily_tasks_etag" ) ?? null } );
  return authGetConditional<DailyTasksPayloadDto>( DAILY_TASKS_PATH, etag );
}

export function claimDailyTask( task_id: string, day?: number ): Promise<ClaimDailyTaskResponse>
{
  return authPost<ClaimDailyTaskResponse>(
    `api/player/me/daily-tasks/${encodeURIComponent( task_id )}/claim`,
    day !== undefined ? { day } : undefined
  );
}

export function claimStarChest( index: number ): Promise<ClaimStarChestResponse>
{
  return authPost<ClaimStarChestResponse>(
    `api/player/me/daily-tasks/chests/${index}/claim`
  );
}
